import { render, staticRenderFns } from "./polygon.vue?vue&type=template&id=4f247a50"
import script from "./polygon.vue?vue&type=script&lang=js"
export * from "./polygon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports